import {tagColors} from "@/components/tag/tag-colors";

export const ProductBrandEnum = {
  status: {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
  },
  stateOption: [
    {id: 'Active', text: '启用',...tagColors.greenText},
    {id: 'Inactive', text: '停用', ...tagColors.gray9Text}
  ]
};
